<template>
  <div class="flex-1 flex flex-col justify-between">
    <h3 class="text-2xl mb-4 font-medium leading-6 text-gray-900 dark:text-dark-body-text">
      {{ $t("Share Feedback") }}
    </h3>
    <p class="text-lg mt-4">
      {{ $t("You can use this form to provide your feedback about RevSetter.") }}
    </p>
    <p class="text-lg mt-4">
      {{ $t("Have an issue you need help with right away?") }}
      <a href="mailto:support@revsetter.com" class="text-blue"> {{ $t("Contact our support team.") }} </a>
    </p>
    <div class="mt-4">
      <p class="text-lg font-bold">
        {{ $t("Type of feedback") }}
      </p>
      <div v-for="option in categories" :key="option.value" class="mt-2">
        <input :id="option.value"
               v-model="selected_category"
               type="radio"
               :value="option.value"
               class="mr-2">
        <label :for="option.value">{{ option.text }}</label>
      </div>
    </div>
    <p class="text-lg font-bold mt-4">
      {{ $t("Details about your feedback") }}
    </p>
    <TextArea
      classes="w-full mt-2"
      input-classes="dark:bg-dark-box-background bg-light-box-background dark:text-dark-body-text px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-md"
      show-label
      :label="$t('Description')"
      name="description"
      @input="description = $event.target.value" />
    <div class="mt-4">
      <input
        id="wants_response"
        v-model="wants_response"
        type="checkbox"
        class="mr-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
      <label for="wants_response">{{ $t("I'd like a response from the RevSetter team.") }}</label>
    </div>
    <div class="flex mt-8 gap-2 w-full flex-row justify-between">
      <button type="button" class="cancel-btn w-1/2 m-0" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
      <button class="primary-btn w-1/2" @click="sendFeedback">{{ $t("Submit") }}</button>
    </div>
  </div>
</template>

<script>
import TextArea from "@/components/shared/TextArea.vue"
import dataService from "@/services/data.service"
export default {
  components: {
    TextArea
  },
  emits: ["cancel", "done"],

  data() {
    return {
      categories: [
        { text: this.$t("Report a bug"), value: "bug" },
        { text: this.$t("Improvement Suggestion"), value: "improvement" },
        { text: this.$t("Feature Request"), value: "feature" },
        { text: this.$t("General Feedback"), value: "general" }
      ],
      selected_category: "bug",
      description: null,
      wants_response: false
    }
  },

  methods: {
    sendFeedback() {
      let data = {
        category: this.selected_category,
        content: this.description,
        wants_response: this.wants_response
      }
      dataService.submitFeedback(data).then(() => {
        this.$emit("done")
      })
    }
  }
}
</script>
